import Compressor from "compressorjs/dist/compressor.esm.js";
import global from "@/prototype/global.js";

import fromBlob from "mime-type";

const log = global.log.getLogger("f_mtac.utils.media");
log.setLevel(log.levels.WARN);

const other_file_type = ["application/gzip", "application/x-gzip", "application/pdf","application/vnd.openxmlformats-officedocument.wordprocessingml.document","application/vnd.openxmlformats-officedocument.wordprocessingml.template","application/vnd.openxmlformats", "text/plain"];

let Media = function() {
    this.binary_to_media = (binary, compress) => {
        log.debug("binary_to_media type ");
        var mime_type = null;
        return fromBlob(binary).then(type => new Promise((resolve, reject) => {
            log.debug("binary_to_media type ",type);
            if (type === undefined) {
                mime_type = "text/plain";
                //try to play it (check if mp3 (not recognized by file-type))
                const test_reader = new FileReader();
                test_reader.addEventListener("load", () => {
                    let test_blob = new Blob([test_reader.result], {type: "audio/mpeg"});
                    const audio = new Audio();
                    const object_url = URL.createObjectURL(test_blob);
                    audio.addEventListener("canplaythrough", () => {
                        URL.revokeObjectURL(object_url);
                        resolve("audio/mpeg");
                    }, false);
                    audio.addEventListener("error", () => {
                        resolve("text/plain");
                    },false);
                    audio.src = object_url;
                }, false);
                test_reader.addEventListener("error", reject);
                test_reader.readAsArrayBuffer(binary); // can take a blob or a file object
                // identify binary data by heuristics here
            } else {
                mime_type = type.mime;
                switch(mime_type) {
                case "application/xml":
                    mime_type = "image/svg+xml";
                    break;
                }
                resolve(mime_type);
            }
        })).then((mime_type) => new Promise((resolve,reject) => {
            const reader = new FileReader();
            reader.addEventListener("load", () => {
                resolve(new Blob([reader.result], {type: mime_type}));
            }, false);
            reader.addEventListener("error", reject);
            reader.readAsArrayBuffer(binary); // can take a blob or a file object
        })).then(media_blob => new Promise((resolve, reject) => {
            let type = mime_type.split("/")[0];
            switch(type) {
            case "image" :
                resolve(this.binary_to_image(media_blob, compress));
                break;
            case "audio" :
                resolve(this.binary_to_audio(media_blob));
                break;
            case "video" :
                resolve(this.binary_to_video(media_blob, mime_type));
                break;
            default :
                if (other_file_type.indexOf(mime_type) === -1) {
                    reject("error");
                    return;
                }
                resolve(this.binary_to_other(media_blob));
            }
        }));
    };
    this.binary_to_image = (media_blob, compress) => {
        log.debug("binary_to_image");
        let new_media = {};
        return new Promise(resolve => {
            if (!compress) {
                resolve(media_blob);
                return;
            }
            new Compressor(media_blob, {
                quality: 0.8,
                success: result => resolve(result),
                error: error => {
                    log.error("error while compressing", error);
                    resolve(media_blob);
                }
            });
        }).then(media_blob => new Promise((resolve, reject) => {
            const image = new Image();
            const object_url = URL.createObjectURL(media_blob);
            image.addEventListener("load", () => {
                new_media.media_data = media_blob;
                new_media.media_info = {width: image.width, height: image.height};
                URL.revokeObjectURL(object_url);
                resolve(new_media);
            }, false);
            image.addEventListener("error", reject);
            image.src = object_url;
        }));
    };
    this.binary_to_audio = (media_blob) => {
        let new_media = {};
        return new Promise((resolve, reject) => {
            const audio = new Audio();
            const object_url = URL.createObjectURL(media_blob);
            audio.addEventListener("canplaythrough", () => {
                new_media.media_data = media_blob;
                //new_media.media_info = undefined;
                URL.revokeObjectURL(object_url);
                resolve(new_media);
            }, false);
            audio.addEventListener("error", reject);
            audio.src = object_url;
        });
    };
    
    this.binary_to_video = (media_blob/*,mime_type*/) => {
        let new_media = {};
        return new Promise((resolve, reject) => {
            let video = document.createElement("video");
            const object_url = URL.createObjectURL(media_blob);
            //let load = video.canPlayType(mime_type);
            video.addEventListener("canplaythrough", () => {
                new_media.media_data = media_blob;
                new_media.media_info = {width: video.videoWidth, height: video.videoHeight};
                URL.revokeObjectURL(object_url);
                resolve(new_media);
            }, false);
            video.addEventListener("error", reject);
            video.src = object_url;
        });
    };
    this.binary_to_other = (media_blob) => {
        let new_media = {};
        return new Promise((resolve) => {
            const object_url = URL.createObjectURL(media_blob);
            new_media.media_data = media_blob;
            new_media.media_info = undefined;
            URL.revokeObjectURL(object_url);
            resolve(new_media);
        });
    };
};
export default new Media();
